<template>
    <div>
        <jet-form-card @submitted="submit">
            <template #form>
                <div class="col-span-6">
                    <jet-label for="name" value="Name"/>
                    <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" required
                               :error="!!form.errors.name"
                               autofocus/>
                    <jet-input-error :message="form.errors.name"/>
                </div>
                <div class="col-span-6">
                    <jet-label for="preview_image" value="Name"/>
                    <jet-input id="preview_image"
                               type="file"
                               @change.prevent="fileSelected"
                               class="mt-1 block w-full"
                               :error="!!form.errors.preview_image"
                    />
                    <jet-input-error :message="form.errors.preview_image"/>
                </div>
            </template>
            <template #actions>
                <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                    Saved.
                </jet-action-message>
                <jet-button :class="{ 'opacity-25': form.processing }"
                            :disabled="form.processing">
                    Save
                </jet-button>
            </template>
        </jet-form-card>
    </div>
</template>

<script>
import JetFormCard from '@/Jetstream/FormCard';
import JetActionMessage from '@/Jetstream/ActionMessage.vue';
import JetInputError from '@/Jetstream/InputError';
import JetInput from '@/Jetstream/Input';
import JetButton from '@/Jetstream/Button';
import JetLabel from '@/Jetstream/Label';
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    name: "QuoteBlockForm",
    components: {
        JetInput,
        JetLabel,
        JetButton,
        JetFormCard,
        JetActionMessage,
        JetInputError,
    },
    props: {
        quoteBlock: {
            type: Object,
            required: false,
        },
    },
    setup(props) {
        const form = useForm({
            name: props.quoteBlock?.name,
            preview_image: null,
        });

        const fileSelected = (event) => {
            form.preview_image = event.target.files[0];
        }

        const submit = () => {
            if (props.quoteBlock) {
                form
                    .transform((data) => ({
                        _method: "put",
                        ...data
                    }))
                    .post(
                        route('admin.quote-block.update', props.quoteBlock.id), {
                            forceFormData: true,
                        });
            }
        }

        return {
            form,
            submit,
            fileSelected
        }
    }
}
</script>

<style scoped>

</style>
